import { AxiosRequestConfig } from 'axios'

export interface FoodPreferenceAnalysisByLevelParams {
  startDate: string
  endDate: string
  storeId?: number
}

export interface FoodPreferenceData {
  name: string
  value: number
  proportion: number
  tagId: string
  code: string
  averageFrequency?: number
}

export interface UserPollQuestion {
  id: number
  question: string
  order: number
  active: boolean
  defaultDashboard: boolean
  answered: number
  detail: Array<{
    id: number
    userPollId: number
    tag: number
    answer: string
    active: boolean
    iconId: string | null
    createdAt: string
    updatedAt: string
    deletedAt: string | null
  }>
}

export interface UserPollQuestionsResponse {
  userPolls: UserPollQuestion[]
}

export interface FoodPreferenceAnalysisByLevelData {
  data: FoodPreferenceData[]
  totalUsers: number
}

export const getUserPollQuestions = (): AxiosRequestConfig => ({
  url: '/user-poll',
  method: 'GET',
})

export const getFoodPreferenceAnalysisByLevel = (
  params: FoodPreferenceAnalysisByLevelParams,
): AxiosRequestConfig => ({
  url: '/dashboard/food-preference-analysis-by-level',
  method: 'GET',
  params,
})
